export default "class SuspenseTimeout extends React.Component {\n  render() {\n    const { data } = this.props\n    if (true) {/* do nothing */}\n  }\n}\n"